import React from 'react';
import { Box, Dialog, Flex, Grid, Text, IconButton } from '@radix-ui/themes';
import { CompanySlide } from 'admin/types';
import { observer } from 'mobx-react-lite';
import { CloseIcon } from 'shared/icons';

const ManagerCardView = ({ slide }: { slide: CompanySlide }) => {
   return (
      <Box className="manager-card">
         <Flex justify="between" align="baseline">
            <Dialog.Title aria-describedby={undefined} color="orange">
               {slide.full_name}
            </Dialog.Title>

            <Dialog.Close>
               <IconButton size="1" color="gray">
                  <CloseIcon width={20} height={20} />
               </IconButton>
            </Dialog.Close>
         </Flex>

         <Box py="2">
            <Grid columns="200px 1fr" gap="3" width="auto">
               <Text weight="bold">Company Name:</Text>
               <Text>{slide.company_name}</Text>
               <Text weight="bold">Position:</Text>
               <Text>{slide.position}</Text>
               <Text weight="bold">Name:</Text>
               <Text>{slide.full_name}</Text>
               <Text weight="bold">Email Address:</Text>
               <Text>{slide.email_address}</Text>
               <Text weight="bold">Address:</Text>
               <Text>{slide.address}</Text>
               <Text weight="bold">Location:</Text>
               <Text>{slide.location}</Text>
               <Text weight="bold">Contact Number:</Text>
               <Text>{slide.contact}</Text>
               <Text weight="bold">Company Number:</Text>
               <Text>{slide.company_contact}</Text>
               <Text weight="bold">Website:</Text>
               <Text>{''}</Text>
            </Grid>
         </Box>
      </Box>
   );
};

export const ManagerCard = observer(ManagerCardView);
